<template>
  <div id="app" v-if="!isCloseAll">
    <router-view/>
  </div>
</template>

<script>
import {mapGetters,mapMutations} from "vuex";
var threshold = 100;
export default {
  name: 'App',
  data(){
    return{
      timer1:null,
      isCloseAll:false,
    }
  },
  methods: {
    ...mapMutations('sys', ['CLEAR_ALL']),
    saveStoreItems() {
      clearInterval(this.timer1);
      window.sessionStorage.setItem("myMenuTree", JSON.stringify(this.getMyMenuTree));
      window.sessionStorage.setItem("loginUser", JSON.stringify(this.getLoginUser));
      window.sessionStorage.setItem("activeMenu", this.getActiveMenu);
      window.sessionStorage.setItem("xtname", this.getXtname);
    },
    jt() {
      if (window.outerWidth - window.innerWidth > threshold || window.outerHeight - window.innerHeight > threshold) {
        // 刷新页面；
        // window.location.reload()
        // alert('请关闭控制台重新输入地址进入网站');
        clearInterval(this.timer1)
        this.isCloseAll = true;
        this.CLEAR_ALL();
        // console.log(this.isCloseAll)
        // window.close();
      }
    }
  },
  computed: {
    ...mapGetters('sys', ['getIsCollapse', 'getMyMenuTree', 'getLoginUser', 'getActiveMenu', 'getXtname'])
  },
  mounted() {
    //监听页面注销
    window.addEventListener('unload', this.saveStoreItems);
    //刷新后设置系统名称
    document.title = this.$store.getters['sys/getXtname'];
  },
  created() {
    // this.$nextTick(() => {
    //   document.title=window.sessionStorage.getItem("sysTitle");
    //   // 禁用右键
    //   document.oncontextmenu = new Function('event.returnValue=false')
    //   // 禁用选择
    //   document.onselectstart = new Function('event.returnValue=false')
    //   //禁止f12
    //   // document.onkeydown = new Function('event.returnValue=false')
    // })
    // this.jt();
    // this.timer1 = setInterval(()=> {
    //   //当浏览器窗口宽度或高度与页面的宽度和高度的差值大于100的时候触发页面刷新
    //   this.jt();
    // })
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #2c3e50;
  /*margin-top: 60px;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue